export default ({ request }) => ({
  userPaymentRequestListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/list',
      method: 'post',
      data,
    })
  },
  userPaymentRequestSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/save',
      method: 'post',
      data,
    })
  },
  userPaymentRequestDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/detail',
      method: 'post',
      data,
    })
  },
  userPaymentRequestDelApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/del',
      method: 'post',
      data,
    })
  },
  userPaymentRequestRejectedApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/force/reject',
      method: 'post',
      data,
    })
  },
  userPaymentRequestSubmitAuditApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/submit',
      method: 'post',
      data,
    })
  },
  userPaymentRequestCheckInvoiceApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/check/invoice',
      method: 'post',
      data,
    })
  },
  userPaymentRequestNoInvoiceApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/no/invoice',
      method: 'post',
      data,
    })
  },
  userPaymentRequestSubmitOaApplyApi(data = {}) {
    return request({
      url: '/oa/user/payment/request/apply',
      method: 'post',
      data,
    })
  },
  userPaymentRequestCheckApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/check',
      method: 'post',
      data,
    })
  },
  userPaymentRequestItemListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/item/list',
      method: 'post',
      data,
    })
  },
  userPaymentRequestDocistApi(data = {}) {
    return request({
      url: '/digitalCenter/user/payment/request/doc/list',
      method: 'post',
      data,
    })
  },
  //查询银行账户信息接口
  masterCustomerBankListApi(data = {}) {
    return request({
      url: '/digitalCenter/master/customer/bank/list',
      method: 'post',
      data,
    })
  },
  masterScmInfoBankListApi(data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/bank/list',
      method: 'post',
      data,
    })
  },
  masterDepSelectByCustApi(data = {}) {
    return request({
      url: '/master/common/dict/depSelectByCust',
      method: 'post',
      data,
    })
  },
})
